import React, { useEffect } from 'react';
import './App.css';
import './output.css';
import LinearGradient from "./components/magicui/linear-gradient";
import { BorderBeam } from "./components/magicui/border-beam";
import NumberTicker from "./components/magicui/number-ticker";
import useWebSocket from 'react-use-websocket';


function App() {

  interface WSMessage {
    count: number
  }

  const [count, setCount] = React.useState(0)
  const WS_URL = "wss://apps.infimasec.com/ws/false"
  const { lastJsonMessage } = useWebSocket<WSMessage>(WS_URL, {
    shouldReconnect: () => true,
  });
  

  useEffect(() => {
    if (lastJsonMessage) {
      setCount(lastJsonMessage.count)
    }
  }, [lastJsonMessage])

  return (
    <div className="relative" style={{minHeight:'100vh'}}>
      <LinearGradient
        from="#0036AC"
        to="#00174A"
      />
      <nav className="relative mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
        <div className="flex lg:flex-1">
          <a href="https://infimasec.com" className="-m-1.5 p-1.5">
            <span className="sr-only">INFIMA Security</span>
            <img className="h-8 w-auto" src="https://static.infimasec.com/images/infima-white.webp" alt="" />
          </a>
        </div>
      </nav>
      <div className=" py-24 sm:py-32">
        <div className="relative isolate">
          <div className="mx-auto max-w-4xl px-2 sm:px-6 lg:px-8">
            <div className="relative mx-auto flex max-w-2xl flex-col gap-16 bg-white/5 px-6 py-16 ring-1 ring-white/10 rounded-3xl sm:p-8 lg:mx-0 lg:max-w-none lg:flex-row lg:items-center lg:py-20 xl:gap-x-20 xl:px-20">
              <BorderBeam 
                colorFrom='#FF13BC'
              />
                <div className="w-full flex-auto">
                  <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">False clicks prevented</h2>
                <p className="mt-6 text-lg leading-8 text-gray-300">Eliminating false clicks provides accurate user results, maintaining client trust in your security awareness program.</p>
                <dl className="mt-10 grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-2">

                  <div className="relative overflow-hidden rounded-lg bg-white px-4 pb-6 pt-5 shadow sm:px-6 sm:pt-6">
                    <dt>
                      <div className="absolute rounded-md bg-blue-500 p-4">
                        <svg className="h-7 w-7 text-white" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zM12 2.25V4.5m5.834.166l-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243l-1.59-1.59" />
                        </svg>
                      </div>
                      <p className="ml-20 text-sm font-medium text-gray-500">This year</p>
                    </dt>
                    <dd className="ml-20 flex items-baseline">
                      <p className="text-2xl font-semibold text-gray-900">
                        <NumberTicker value={count} startValue={0} direction="up" delay={0.1} className="text-4xl font-semibold text-gray-900" />
                      </p>
                    </dd>
                  </div>

                  <ul className="grid grid-cols-1 gap-x-8 gap-y-3 text-base leading-7 text-white">
                    <li className="flex gap-x-3">
                      <svg className="h-7 w-5 flex-none" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
                      </svg>
                      Use any spam protection solution
                      
                    </li>
                    <li className="flex gap-x-3">
                      <svg className="h-7 w-5 flex-none" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
                      </svg>
                      Protect client trust in your services
                    </li>
                    <li className="flex gap-x-3">
                      <svg className="h-7 w-5 flex-none" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
                      </svg>
                      Stop explaining what went wrong
                    </li>
                  </ul>
                  </dl>
                  <div className="z-10 mt-10 flex relative">
                    <a href="https://infimasec.com/talk-to-zach/" className="text-sm font-semibold leading-6 text-indigo-200">Schedule a demo <span aria-hidden="true">&rarr;</span></a>
                  </div>
                </div>
            </div>
          </div>
          <div className="absolute inset-x-0 -top-16 -z-10 flex transform-gpu justify-center overflow-hidden blur-3xl" aria-hidden="true">
            <div className="aspect-[1318/752] w-[82.375rem] flex-none bg-gradient-to-r from-[#80caff] to-[#4f46e5] opacity-25" style={{clipPath: 'polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%)'}}></div>
          </div>
        </div>
      </div>

      
    </div>
  );
}

export default App;
